/**
 * Antd 5 · 工业现代浅色主题
 * 设计依据: design/v1.0-prototype.html
 */
import type { ThemeConfig } from "antd";

export const industrialTheme: ThemeConfig = {
  token: {
    colorPrimary: "#FF6B00", // 工业安全橙
    colorSuccess: "#006B3C",
    colorWarning: "#E48900",
    colorError: "#C8102E",
    colorInfo: "#0046AD",

    colorBgBase: "#FAF8F2",
    colorTextBase: "#0A0908",
    colorBorder: "#DCD7C9",
    colorBorderSecondary: "#E8E3D5",

    fontFamily:
      '"IBM Plex Sans", "Source Han Sans SC", "Noto Sans SC", sans-serif',
    fontSize: 14,
    borderRadius: 2,
    borderRadiusLG: 4,
    borderRadiusSM: 2,
    wireframe: false,
  },
  components: {
    Layout: {
      bodyBg: "#FAF8F2",
      headerBg: "#FAF8F2",
      siderBg: "#FAF8F2",
      headerHeight: 56,
    },
    Button: {
      fontWeight: 500,
      defaultBorderColor: "#0A0908",
      defaultColor: "#0A0908",
    },
    Table: {
      headerBg: "#F4F1E8",
      headerColor: "#847E72",
      headerSplitColor: "#DCD7C9",
      borderColor: "#E8E3D5",
    },
    Card: {
      colorBorderSecondary: "#DCD7C9",
      headerBg: "#F4F1E8",
    },
    Menu: {
      itemBg: "transparent",
      itemSelectedBg: "#F4F1E8",
      itemHoverBg: "#F4F1E8",
      itemActiveBg: "#F4F1E8",
      itemSelectedColor: "#0A0908",
      activeBarBorderWidth: 3,
    },
    Tag: {
      defaultBg: "#F4F1E8",
      defaultColor: "#1F1B16",
    },
  },
};
